import cn from "classnames";
import { memo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { analytics } from "@rshbintech.dboul/analytics";
import { Text, useMediaQuery } from "@rshbintech.dboul/core-ui";
import { createMetricDataObject } from "../../../common/utils/create-metric-data-object";
import { camelize } from "../../../common/utils/camelize";
import { MenuItemProps } from "./types";
import styles from "./styles.scss";

export const MenuItem = memo(
  ({
    name,
    path,
    disabled,
    metricName,
    metricData,
    dataTestId,
    icon: Icon,
    isMenuOpen,
    onMenuItemClick,
    className,
  }: MenuItemProps) => {
    const navigate = useNavigate();
    const location = useLocation();

    const isDesktop = useMediaQuery("desktop");
    const xl = useMediaQuery("xl");
    const xxl = useMediaQuery("xxl");

    if (disabled) {
      return null;
    }

    const isActiveMenuItem = location.pathname.startsWith(path);

    const handleMenuItemClick = () => {
      if (isMenuOpen) {
        onMenuItemClick?.();
      }

      if (path) {
        analytics.sendEvent(metricName, createMetricDataObject(metricData));
        navigate(path);
      }
    };

    /**
     * Для сохранения обратной совместимости с mindbox,
     * свойство metricData приводится к формату camelCase + Click.
     * После отказа от mindbox и переименования поля metricData в camelCase, необходимо убрать эту часть кода
     * */
    const dataRptrackerAction = camelize(metricData) + "Click";

    return (
      <span
        onClick={handleMenuItemClick}
        data-test-id={dataTestId}
        data-rptracker-event="click"
        data-rptracker-category="dboMenu"
        data-rptracker-action={dataRptrackerAction}
        className={cn(styles["menu-item"], {
          [styles.active]: isActiveMenuItem,
        })}
      >
        {Icon && (
          <Icon className={styles.icon} size={xl || xxl ? "medium" : "small"} />
        )}
        <Text
          className={className}
          weight={isActiveMenuItem ? "medium" : "regular"}
        >
          {(isDesktop || isMenuOpen) && name}
        </Text>
      </span>
    );
  }
);
